import ProcessingClient from '@/services/clients/processing';
import { UserGroup } from '@/types';

interface User {
    userGroup?: string;
    allowWebWalletsByUserCountry?: boolean;
    firstName?: string;
    lastName?: string;
    [key: string]: unknown;
}

interface UserState {
    user: User;
}

export default {
    namespaced: true,
    state: {
        user: {},
    } as UserState,
    getters: {
        user: (state: UserState): User => state.user,
        isCorporateUser: (state: UserState): boolean => state.user.userGroup === UserGroup.CORPORATE,
        isAllowWebWalletsByUserCountry: (state: UserState): boolean | undefined => state.user.allowWebWalletsByUserCountry,
        fullName: (state: UserState): string => [state.user.firstName, state.user.lastName].filter(el => el).join(' '),
    },
    mutations: {
        setUser(state: UserState, payload: User): void {
            state.user = payload;
        },
    },
    actions: {
        async fetchUser({ commit }: { commit: (mutation: string, payload: User) => void }): Promise<void> {
            const user = await ProcessingClient.getUser();
            return commit('setUser', user);
        },
    }
};
